// MultiSelectDropdown.jsx
import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const MultiSelectDropdown = ({
  options = [],
  value = [],
  onChange,
  label = "Select options",
  placeholder = "Select...",
  disabled = false
}) => {
  return (
    <div className="w-full">
      <Autocomplete
        multiple
        disableCloseOnSelect
        options={options}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterSelectedOptions
        value={value}
        onChange={(event, newValue) => onChange(newValue)}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label={label}
            placeholder={placeholder}
            className="!bg-white"
          />
        )}
        sx={{
          '& .MuiOutlinedInput-root': {
            padding: '4px 4px',
          },
          '& .MuiChip-root': {
            margin: '2px',
          },
        }}
      />
    </div>
  );
};

export default MultiSelectDropdown;
